import React, { useEffect } from 'react';
import Input from 'components/partials/Fields/Input';
import { safeKeyCode, scrollTo } from 'helpers/page';
import CheckboxGroup from 'components/partials/Fields/CheckboxGroup';
import LoadingIndicator from '../partials/LoadingIndicator';
import { Icon } from '../Icon';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function AuctionFilters(props) {
    const filterTypes = [
        {
            name: 'lien-unit',
            label: 'Lien Unit',
            value: '1',
        },
        {
            name: 'non-lien-unit',
            label: 'Non-Lien Unit/Manager Special',
            value: '2',
        },
        {
            name: 'private-seller',
            label: 'Non-Lien Unit/Private Seller',
            value: '4',
        },
        {
            name: 'charity-unit',
            label: 'Charity Unit',
            value: '3',
        },
    ];

    useEffect(() => {
        const handleKeyUp = (e) => {
            if (safeKeyCode(e) === 27 /* escape key */) props.onHide();
        };

        typeof window !== 'undefined' && window.addEventListener('keyup', handleKeyUp);
        return () => typeof window !== 'undefined' && window.removeEventListener('keyup', handleKeyUp);
    }, []);


    const handleFormSubmit = (e) => {
        e.preventDefault();
        scrollTo(0, 0);
        props.onHide && props.onHide();
        props.redoSearch && props.redoSearch();
    };

    const {
        auctionCategories,
        updateMethod,
        showSidebar,
        search_obj: {
            filter_unit_contents = '',
            filter_types = [],
            filter_categories = [],
        },
    } = props;

    return (
        <div className={`filters-container ${showSidebar ? 'filter-sidebar-open h-100' : ''}`}>
            <form onSubmit={handleFormSubmit}>
                <div className={`filters pb-2 d-flex justify-content-between align-items-center ${showSidebar ? 'shadow-sm' : ''}`}>
                    <p className="m-0">Filters</p>
                    {showSidebar &&
                        <>
                            <button
                                className="btn btn-primary"
                                type="submit"
                            >
                                Update Results
                            </button>
                            <Icon
                                className="ml-2 cursor-pointer"
                                size="xl"
                                icon={faTimes}
                                onClick={props.onHide}
                            />
                        </>
                    }
                </div>
                <div className="filter-title filter-title-first">Auction Type</div>
                <div className="filter-types">
                    <div>
                        <CheckboxGroup
                            name="filter_types"
                            required={false}
                            options={filterTypes}
                            values={filter_types}
                            updateMethod={props.updateMethod}
                            optionLabel="label"
                            optionValue="value"
                            withGroupWrapper
                            containerClassName=""
                        />
                        <div className="clearfix" />
                    </div>
                </div>
                <div className="filter-title">Unit Contents</div>
                <div className="filter-keywords">
                    <div className="keywords-title">Enter search term(s)</div>
                    <Input name="filter_unit_contents" value={filter_unit_contents} updateMethod={updateMethod} />
                </div>
                <div className="filter-title">Categories</div>
                <div className="filter-categories">
                    {auctionCategories.length > 0 ? (
                        <CheckboxGroup
                            name="filter_categories"
                            required={false}
                            options={auctionCategories}
                            values={typeof filter_categories === 'string' ? [filter_categories] : filter_categories}
                            updateMethod={updateMethod}
                            optionLabel="category_name"
                            optionValue="category_id"
                            optionId="slug"
                            withGroupWrapper
                        />
                    ) : <LoadingIndicator />}
                </div>
                {showSidebar ||
                    <button
                        className="btn btn-primary marginT20 w-100"
                        type="submit"
                    >
                        Update Results
                    </button>
                }
            </form>
        </div>
    );
}

export default AuctionFilters;